import {takeLatestF, putAll, showSuccess, extractFormErrorsFromResponse, NullableKeys} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {genNakedPropOrCrash, opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {CreateAssociationBinding} from 'api/gen/CreateAssociationBinding';
import {t} from 'app/translations';
import {userDetailAction} from 'app/user-detail';
import {subjectFormName, SubjectFormValues} from 'app/user-detail/types/subject-form-values';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {adminAction, CreateAssociationRolesAction} from '../action';

const te = t('common');
const title = te('createEntry');

const buildValuesForApi = (formValues: NullableKeys<SubjectFormValues>): CreateAssociationBinding => {
    const get = genNakedPropOrCrash(formValues);

    return {
        approvedFrom: get('approvedFrom'),
        approvedTo: opt(formValues).prop('approvedTo').orNull(),
        roleIds: get('roleIds'),
        associationId: get('subjectId'),
        userProfileId: get('userProfileId'),
    };
};

function* execute(_: CreateAssociationRolesAction): SagaIterator {
    const formValues = yield* select(state => formHelpers.formValues(subjectFormName)(state)
        .orCrash('no form values'));
    yield* put(formHelpers.startSubmit(subjectFormName));

    const response = yield* call(Api.addUserProfileAssociationRoleBinding, buildValuesForApi(formValues));

    if (response.isSuccess) {
        const userProfileId = opt(formValues.userProfileId).orCrash('No userProfileId found');

        yield* put(adminAction.getAssociations(opt({action: 'refresh'}), userProfileId));
        yield* put(showSuccess(title, te('createEntrySuccess'), false, 'createRolesForAssociation'));
        yield* put(userDetailAction.setAssociationsModalVisible(null));
        yield* put(formHelpers.reset(subjectFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(subjectFormName, extractFormErrorsFromResponse(response)));
    }
}

/** Runs the admin saga that creates association-role bindings from the admin form. */
export function* createAssociationRolesSaga(): SagaIterator {
    yield takeLatestF('admin/CREATE_ASSOCIATION_ROLES', execute);
}
